import React from 'react';
import Button from '../../../components/button/Button';
import { BUTTON_TYPE } from '../../../components/button/constants';
import styles from './IRSTypeFormSubmitPopup.styles';
import Popup from '../../../components/popup/Popup';
import IRSLayoutRenderer from '../../../components/irsformview/IRSLayoutRenderer';
import Loadable from '../../../components/loadable/Loadable';

export default function IRSTypeFormSubmitPopup({ 
    title, 
    isPopupOpen,
    isClose = true,
    onCloseCb = () => { },
    confirmationButtonProps = {
        onConfirmationCb: () => { },
        confirmationButtonText: "Save",
        confirmationButtonStyles: {},
        confirmationButtonType: BUTTON_TYPE.PRIMARY,
    },
    cancelButtonProps = {
        onCancelCb: () => { },
        cancelButtonText: "Cancel",
        cancelButtonStyles: {},
        cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
    },
    customStyle = {},
    tempFormFieldsList = [],
    toCreateFormData = {},
    formsPreLoadedData = {},
    isSingleFormCreationModule = false,
    onChangeCb = () => {},
    onBlurCb = () => {},
    handleIRSFormSubmitCb = () => {},
    dispatchNotificationCb = () => {},
    userInteractionPopupWResponseObj = {},
    loadingState=false,
    loaderLoadingStates=[],
    loaderMessageMap={},
}) {

    return <>
        <Popup 
            title={title}
            isPopupOpen={isPopupOpen}
            onCloseCb={isClose ? cancelButtonProps?.onCancelCb : onCloseCb} 
            showClose={true}
            customPopupSyles={{...styles.customPopupStyles, ...customStyle}}
        >
            <Loadable
                currentState={loadingState?.state}
                loadingStates={loaderLoadingStates} 
                isNewLoadable={true}
                messageMap={loaderMessageMap}
            >
                <IRSLayoutRenderer
                    tempFormFieldsList={tempFormFieldsList}
                    toCreateFormData={toCreateFormData}
                    formsPreLoadedData={formsPreLoadedData}
                    isIRSViewOn={true}
                    onChangeCb={(e, field) => onChangeCb(e, field)}
                    onBlurCb={(e, inputValidationResult, field) => onBlurCb(e, inputValidationResult, field)}
                    handleIRSFormSubmitCb={handleIRSFormSubmitCb}
                    isSingleFormCreationModule={isSingleFormCreationModule}
                    dispatchNotificationCb={dispatchNotificationCb}
                    userInteractionPopupWResponseObj={userInteractionPopupWResponseObj}
                />
                
                <div style={styles.footer}>

                    {confirmationButtonProps.confirmationButtonText && <div onClick={confirmationButtonProps.onConfirmationCb}>
                        <Button
                            type={confirmationButtonProps.confirmationButtonType}
                            style={{ ...confirmationButtonProps.confirmationButtonStyles, ...styles.button }}
                        >
                            {confirmationButtonProps.confirmationButtonText}
                        </Button>
                    </div>}

                    {
                        cancelButtonProps !== null && <div onClick={cancelButtonProps.onCancelCb}>
                            <Button
                                type={cancelButtonProps.cancelButtonType}
                                style={{ ...cancelButtonProps.cancelButtonStyles, ...styles.button }}
                            >
                                {cancelButtonProps.cancelButtonText}
                            </Button>
                        </div>
                    }

                </div>
            </Loadable>
        </Popup>
    </>
}